import { Text, TextButton } from "@amzn/storm-ui";
import React from "react";

interface ErrorNotificationProps {
    errorType: "download" | "preview" | "generate" | "salesforce";
    onReportClick: () => void;
}

const ErrorNotificationWithLink: React.FC<ErrorNotificationProps> = ({
    errorType,
    onReportClick,
}) => {
    const getMessage = () => {
        switch (errorType) {
            case "download":
                return "Your insight failed to download.";
            case "preview":
                return "Your insight failed to preview.";
            case "generate":
                return "Your insight failed to generate.";
            case "salesforce":
                return "Your salesforce association failed.";
            default:
                return "An error occurred.";
        }
    };

    return (
        <Text>
            {getMessage()} If issue persists, please{" "}
            <TextButton
                onClick={onReportClick}
                style={{ display: "inline", padding: 0 }}
            >
                Report an issue
            </TextButton>
        </Text>
    );
};

export default ErrorNotificationWithLink;

export const DownloadErrorNotification: React.FC<{
    onReportClick: () => void;
}> = ({ onReportClick }) => (
    <ErrorNotificationWithLink
        errorType="download"
        onReportClick={onReportClick}
    />
);

export const PreviewErrorNotification: React.FC<{
    onReportClick: () => void;
}> = ({ onReportClick }) => (
    <ErrorNotificationWithLink
        errorType="preview"
        onReportClick={onReportClick}
    />
);

export const GenerationErrorNotification: React.FC<{
    onReportClick: () => void;
}> = ({ onReportClick }) => (
    <ErrorNotificationWithLink
        errorType="generate"
        onReportClick={onReportClick}
    />
);

export const SalesforceErrorNotification: React.FC<{
    onReportClick: () => void;
}> = ({ onReportClick }) => (
    <ErrorNotificationWithLink
        errorType="salesforce"
        onReportClick={onReportClick}
    />
);
